import path from 'ramda/es/path';
import api from 'app/actions/api';
import { popup } from 'app/common/actions/popup';
import i18n from 'app/i18n';

/**
/* Отмена подписки
*/

export const SUB_STOP_REQUEST = 'SUB_STOP_REQUEST';
export const SUB_STOP_SUCCESS = 'SUB_STOP_SUCCESS';
export const SUB_STOP_FAILURE = 'SUB_STOP_FAILURE';

export const subStopRequest = () => ({
  type: SUB_STOP_REQUEST,
});

export const subStopSuccess = payload => ({
  type: SUB_STOP_SUCCESS,
  payload,
});

export const subStopFailure = errString => ({
  type: SUB_STOP_FAILURE,
  payload: { err: errString },
});


export const subStop = id => async (dispatch) => {
  dispatch(subStopRequest());
  let res;
  try {
    res = await api('cabinet/subscriptions/unsubscribe', 'post', { data: { id } });
  } catch (error) {
    dispatch(subStopFailure(i18n.t('app:request_subscribe_deactivation_failed')));
  }
  const ids = path(['data', 'subscription_ids'], res);
  dispatch(subStopSuccess({ ids }));
  dispatch(popup(i18n.t('app:request_subscribe_deactivation_success')));
};


/**
/* Пауза/возобновление подписки
*/

export const SUB_PAUSE_RESUME_REQUEST = 'SUB_PAUSE_RESUME_REQUEST';
export const SUB_PAUSE_RESUME_SUCCESS = 'SUB_PAUSE_RESUME_SUCCESS';
export const SUB_PAUSE_RESUME_FAILURE = 'SUB_PAUSE_RESUME_FAILURE';

export const subPauseResumeRequest = () => ({
  type: SUB_PAUSE_RESUME_REQUEST,
});

export const subPauseResumeSuccess = data => ({
  type: SUB_PAUSE_RESUME_SUCCESS,
  payload: data,
});

export const subPauseResumeFailure = errString => ({
  type: SUB_PAUSE_RESUME_FAILURE,
  payload: { err: errString },
});


export const subPauseResume = (id, isResume) => async (dispatch) => {
  dispatch(subPauseResumeRequest());
  try {
    const { data } = await api(`cabinet/subscriptions/${isResume ? 'resume' : 'pause'}`, 'post', { data: { id } });
    if (data.result) {
      delete data.result;
    }
    dispatch(subPauseResumeSuccess({ subs: data }));
    dispatch(popup(isResume
      ? i18n.t('app:request_subscribe_resume_success')
      : i18n.t('app:request_subscribe_pause_success')));
  } catch (error) {
    dispatch(subPauseResumeFailure(i18n.t('app:request_subscribe_change_failed')));
  }
};

/**
/* Редактирование подписки
*/

export const SUB_EDIT_REQUEST = 'SUB_EDIT_REQUEST';
export const SUB_EDIT_SUCCESS = 'SUB_EDIT_SUCCESS';
export const SUB_EDIT_FAILURE = 'SUB_EDIT_FAILURE';

export const subEditRequest = () => ({
  type: SUB_EDIT_REQUEST,
});

export const subEditSuccess = data => ({
  type: SUB_EDIT_SUCCESS,
  payload: data,
});

export const subEditFailure = errString => ({
  type: SUB_EDIT_FAILURE,
  payload: { err: errString },
});


export const subEdit = (subId, modified, cb) => async (dispatch) => {
  const putData = {
    id: subId,
    modified,
  };
  dispatch(subEditRequest());
  try {
    const { data } = await api('cabinet/subscriptions/', 'put', { data: putData });
    if (data.result) {
      delete data.result;
    }
    dispatch(subEditSuccess({ subs: data }));
    dispatch(popup(i18n.t('app:request_subscribe_edit_success')));
    if (typeof cb === 'function') {
      cb();
    }
  } catch (error) {
    dispatch(subEditFailure(i18n.t('app:request_subscribe_edit_failed')));
  }
};
